/**
 * Authentication hook for cookie-based auth.
 * The app uses HttpOnly cookie sessions managed by AuthContext.
 * This file exists as a thin compatibility shim for components
 * that were written against the old token-based interceptor API.
 */

import { toast } from 'react-hot-toast';
import { useAuth } from '../../contexts/AuthContext';
import { useUserStateBridge } from '../../hooks/enterprise/useUserStateBridge';

// React Hook for authentication state
export const useAuthInterceptor = () => {
  const { logout: authContextLogout, isAuthenticated, revalidateAuth } = useAuth();
  const { clearUserData } = useUserStateBridge();

  const logout = (message?: string) => {
    clearUserData();

    if (message) {
      toast.error(message, {
        duration: 5000,
        position: 'top-center',
      });
    }

    authContextLogout();
  };

  return {
    logout,
    isAuthenticated,
    forceRefresh: revalidateAuth,
    authInterceptor: null, // Deprecated
  };
};
